<template>
  <b-container>
    <form ref="formDownloadSvg" :action="`${$config.API_URL}download`" method="post">
      <input type="hidden" name="idVector" :value="actualVector.id" />
      <input id="downloadSize" type="hidden" name="size" :value="svgDownload.size" />
      <input id="downloadType" type="hidden" name="type" :value="svgDownload.type" />
    </form>
    <b-row v-if="!downloaded" class="my-5 position-relative">
      <div v-if="isDownloading" class="loading-container position-absolute w-100 h-100">
        <Loading />
      </div>
      <b-col lg="6" class="px-2">
        <WaitToDownload :url-download="urlDownload" @download="download" />
      </b-col>
      <b-col lg="6" class="px-2">
        <SubscribersCard />
      </b-col>
    </b-row>
    <DownloadSuccessful v-else />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';

import DownloadSuccessful from './DownloadSuccessful.vue';
import Loading from 'UI/Loading';
import SubscribersCard from './SubscribersCard.vue';
import WaitToDownload from './WaitToDownload.vue';

export default {
  name: 'Download',
  components: {
    DownloadSuccessful,
    Loading,
    SubscribersCard,
    WaitToDownload
  },
  data: () => {
    return {
      downloaded: false,
      isDownloading: false,
      pathDownload: '',
      urlDownload: '#'
    };
  },
  computed: {
    ...mapGetters('downloads', ['svgDownload']),
    ...mapState('vectors', ['actualVector'])
  },
  beforeDestroy() {
    this.$store.commit('downloads/SET_SVG_DOWNLOAD', { size: 1920, type: 'png', editedSvg: '' });
  },
  methods: {
    async download() {
      try {
        this.isDownloading = true;
        this.urlDownload = this.actualVector.urlDownload;
        this.pathDownload = this.$store.getters['downloads/pathDownload']({
          type: this.actualVector.isSvg ? 'png-svg' : 'vector',
          id: this.actualVector.id,
          slug: this.actualVector.canonizedName
        });

        if (this.actualVector.isSvg) {
          const { type, editedSvg } = this.svgDownload;
          if (editedSvg) {
            this.downloadEditedSvg({ type, editedSvg });
          } else {
            this.$ga.page(this.pathDownload);
            this.$store.commit('downloads/SET_DOWNLOADED', true);
            this.$refs.formDownloadSvg.submit();
          }
        } else {
          const id = this.actualVector.id;
          const data = { id, url: this.urlDownload };
          this.$ga.page(this.pathDownload);
          await this.$store.dispatch('downloads/DOWNLOAD_VECTOR', data);
        }

        this.isDownloading = false;
        setTimeout(() => {
          this.downloaded = true;
        }, 2000);
      } catch ({ message }) {
        console.error(message);
      }
    },
    async downloadEditedSvg({ type, editedSvg }) {
      let data = {
        id: this.actualVector.id,
        name: this.actualVector.canonizedName,
        type,
        url: editedSvg,
        isSvg: true
      };

      this.$ga.page(this.pathDownload);
      await this.$store.dispatch('downloads/DOWNLOAD_VECTOR', data);
    }
  }
};
</script>

<style lang="scss">
.loading-container {
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.7);
}
</style>
